import { render } from "./ResetRequestView.vue?vue&type=template&id=3f7dfe1d"
import script from "./ResetRequestView.vue?vue&type=script&lang=js"
export * from "./ResetRequestView.vue?vue&type=script&lang=js"

import exportComponent from "/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__